import * as tslib_1 from "tslib";
import { BaseParameterDto } from '../../_models/base-parameter-dto';
import { Type } from 'class-transformer';
const ɵ0 = () => Date;
export class OwnerSearchResultDto extends BaseParameterDto {
    get openBalanceUrl() {
        return 'Open Balance';
    }
    get statementUrl() {
        return 'Statement';
    }
}
tslib_1.__decorate([
    Type(ɵ0),
    tslib_1.__metadata("design:type", Date)
], OwnerSearchResultDto.prototype, "buyerCloseDate", void 0);
export { ɵ0 };
